import { Group } from './Group';
import { Company, defaultCompany } from './Company';
import { Preference } from './Preference';

export interface User {
    id?: number;
    first_name?: string;

    is_active?: boolean;
    last_name?: string;
    second_last_name?: string;
    password?: string;

    repeat_password?: string;
    email?: string;
    groups?: Group[];
    avatar?: File;
}

export interface UserPasswordDataForm {
    old_password?: string;
    password?: string;
    repeat_password?: string;
}

export interface IconPasswordChange {
    value: boolean;
    type: string;
}

export const defaultIconPasswordChange: IconPasswordChange = {
    value: true,
    type: 'password'
};

export const defaultUser: User = {
    first_name: '',
    last_name: '',
    second_last_name: '',
    email: '',
    password: '',
    groups: undefined,
    is_active: true,
    avatar: undefined
};

export const defaultUserPasswordDataForm: UserPasswordDataForm = {
    password: '',
    repeat_password: ''
};

export interface UserFilters {
    rut?: string | null;
    first_name?: string | null;
    last_name?: string | null;
    second_last_name?: string | null;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export interface CompanyUser {
    user_id: number;
    company_id: number;
    user: User;
    company: Company;
    job_title?: string;
    phone_code?: string;
    phone?: string;
    is_legal_representative: boolean;
}

export const defaultCompanyUser: CompanyUser = {
    company: defaultCompany,
    user: defaultUser,
    user_id: 0,
    company_id: 0,
    job_title: '',
    phone_code: '+56',
    phone: '',
    is_legal_representative: false
};

export interface ParticipantUser {
    id: number;
    user_id: number;
    user?: User;
    web?: string;
    preferences?: Preference[];
    job_position?: string;
    company?: string;
    years_of_experience?: number;
    description?: string;
}

export const defaultParticipantUser: ParticipantUser = {
    id: 0,
    user_id: 0,
    web: '',
    job_position: '',
    company: '',
    years_of_experience: 0,
    description: '',
    preferences: []
};
